export const getTripDetailEndpoint = (tripId) =>
  tripId ? `issuance/policies/trip/${tripId}/` : null;
